import { __ } from '@wordpress/i18n';
import { InspectorControls } from '@wordpress/block-editor';
import {
  BaseControl,
  __experimentalToggleGroupControl as ToggleGroupControl,
  __experimentalToggleGroupControlOption as ToggleGroupControlOption,
} from '@wordpress/components';

import PanelBody from '../../components/PanelBody';
import ColorPicker from '../../components/ColorPicker';
import Slider from '../../components/Slider';

export default function Inspector({ attributes, setAttributes }) {
  const { layout, alignment, iconSize, iconColor, iconGap, gap } = attributes;

  return (
    <InspectorControls>
      <PanelBody title={__('Layout', 'brandy-blocks')} initialOpen>
        <ToggleGroupControl
          label={__('Direction', 'brandy-blocks')}
          value={layout}
          onChange={(value) => setAttributes({ layout: value })}
          isBlock
          __nextHasNoMarginBottom
        >
          <ToggleGroupControlOption
            value="vertical"
            label={__('Vertical', 'brandy-blocks')}
          />
          <ToggleGroupControlOption
            value="horizontal"
            label={__('Horizontal', 'brandy-blocks')}
          />
        </ToggleGroupControl>

        {/*
         * One control whichever way the list runs: it moves the lines across
         * a vertical list and along a horizontal one.
         */}
        <ToggleGroupControl
          label={__('Alignment', 'brandy-blocks')}
          value={alignment || 'left'}
          onChange={(value) => setAttributes({ alignment: value })}
          isBlock
          __nextHasNoMarginBottom
        >
          <ToggleGroupControlOption
            value="left"
            label={__('Left', 'brandy-blocks')}
          />
          <ToggleGroupControlOption
            value="center"
            label={__('Center', 'brandy-blocks')}
          />
          <ToggleGroupControlOption
            value="right"
            label={__('Right', 'brandy-blocks')}
          />
        </ToggleGroupControl>

        <Slider
          label={__('Space between lines (px)', 'brandy-blocks')}
          value={gap}
          onChange={(value) => setAttributes({ gap: value })}
          min={0}
          max={64}
        />
      </PanelBody>

      <PanelBody title={__('Icons', 'brandy-blocks')} initialOpen>
        <Slider
          label={__('Size (px)', 'brandy-blocks')}
          value={iconSize}
          onChange={(value) => setAttributes({ iconSize: value })}
          min={10}
          max={64}
        />

        <Slider
          label={__('Space before text (px)', 'brandy-blocks')}
          value={iconGap}
          onChange={(value) => setAttributes({ iconGap: value })}
          min={0}
          max={40}
        />

        <BaseControl.VisualLabel>
          {__('Icon color', 'brandy-blocks')}
        </BaseControl.VisualLabel>
        <ColorPicker
          color={iconColor}
          onChange={(value) => setAttributes({ iconColor: value })}
        />
      </PanelBody>
    </InspectorControls>
  );
}
